<template>
  <div>
    <Header Act="7"></Header>
    <div class="training-page" v-if="isLoggedIn">
      <!-- 搜索区域 -->
      <div class="search-section">
        <el-form :inline="true" :model="searchForm" class="search-form">
          <el-form-item label="项目编号">
            <el-input
              v-model="searchForm.projectCode"
              placeholder="请输入项目编号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="项目主题">
            <el-input
              v-model="searchForm.projectCase"
              placeholder="请输入项目主题"
              clearable
            ></el-input>
          </el-form-item>
          -->
          <el-form-item label="作品名称">
            <el-input
              v-model="searchForm.worksName"
              placeholder="请输入作品名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="作者姓名">
            <el-input
              v-model="searchForm.userName"
              placeholder="请输入作者姓名"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="单位">
            <el-input
              v-model="searchForm.userUnit"
              placeholder="请输入单位"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 科普文章 -->
      <div class="section">
        <div class="section-header">
          <h2>培训文件</h2>
          <div class="view-all" @click="viewAllWorks('1')">全部作品</div>
        </div>
        <div class="works-grid">
          <div
            v-for="item in articleItems"
            :key="item.id"
            class="works-item"
            :data-type="item.type"
            @click="handleItemClick(item)"
          >
            <div class="works-player-wrap">
              <div class="works-container">
                <img
                  v-if="item.picFile"
                  :src="item.picFile"
                  :alt="item.worksName"
                  class="works-cover"
                />
                <img
                  v-else
                  src="../../assets/applyRey/word.png"
                  :alt="item.worksName"
                  class="works-cover"
                />
              </div>
            </div>
            <div class="works-title">{{ item.worksName }}</div>
          </div>
        </div>
      </div>

      <!-- 科普图画 -->
      <!-- <div class="section">
        <div class="section-header">
          <h2>科普图画</h2>
          <div class="view-all" @click="viewAllWorks('2')">全部作品</div>
        </div>
        <div class="works-grid">
          <div v-for="item in pictureItems" 
               :key="item.id" 
               class="works-item" 
               :data-type="item.type"
               @click="handleItemClick(item)">
            <div class="works-player-wrap">
              <div class="works-container">
                <img 
                  :src="item.workPicFile || 'https://via.placeholder.com/400x300?text=暂无图片'" 
                  :alt="item.worksName"
                  class="works-cover"
                >
              </div>
            </div>
            <div class="works-title">{{ item.worksName }}</div>
          </div>
        </div>
      </div> -->

      <!-- 科普短视频 -->
      <div class="section">
        <div class="section-header">
          <h2>培训视频</h2>
          <div class="view-all" @click="viewAllWorks('3')">全部作品</div>
        </div>
        <div class="works-grid">
          <div
            v-for="item in videoItems"
            :key="item.id"
            class="works-item"
            :data-type="item.type"
            @click="handleItemClick(item)"
          >
            <div class="works-player-wrap">
              <div class="works-container">
                <div class="video-container">
                  <img
                    v-if="item.picFile"
                    :src="item.picFile"
                    :alt="item.worksName"
                    class="works-cover"
                  />
                  <el-image
                    v-else
                    :alt="item.worksName"
                    class="works-cover"
                    fit="cover"
                    src="../../assets/applyRey/mp4.jpg"
                  >
                    <div slot="placeholder" class="loading-overlay">
                      <i class="el-icon-loading"></i>
                    </div>
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                  <div
                    v-if="loadingThumbnails[item.id]"
                    class="loading-overlay"
                  >
                    <i class="el-icon-loading"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="works-title">{{ item.worksName }}</div>
          </div>
        </div>
      </div>

      <!-- 科普讲座 -->
      <!-- <div class="section">
        <div class="section-header">
          <h2>科普讲座</h2>
          <div class="view-all" @click="viewAllWorks('4')">全部作品</div>
        </div>
        <div class="works-grid">
          <div v-for="item in lectureItems" 
               :key="item.id" 
               class="works-item" 
               :data-type="item.type"
               @click="handleItemClick(item)">
            <div class="works-player-wrap">
              <div class="works-container">
                <div class="video-container">
                  <img 
                    v-if="item.picFile"
                    :src="item.picFile"
                    :alt="item.worksName"
                    class="works-cover"
                  >
                  <el-image 
                    v-else
                    :alt="item.worksName"
                    class="works-cover"
                    fit="cover"
                    src="../../assets/applyRey/mp4.jpg"
                  >
                    <div slot="placeholder" class="loading-overlay">
                      <i class="el-icon-loading"></i>
                    </div>
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                  <div v-if="loadingThumbnails[item.id]" class="loading-overlay">
                    <i class="el-icon-loading"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="works-title">{{ item.worksName }}</div>
          </div>
        </div>
      </div> -->
    </div>
    <!-- 添加登录弹窗 -->
    <el-dialog
      title="登录"
      :visible.sync="loginDialogVisible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      :before-close="handleDialogClose"
      custom-class="login-dialog"
    >
      <div class="login-form">
        <div class="login-tabs">
          <button
            :class="{ active: activeTab === 'verifyCode' }"
            @click="activeTab = 'verifyCode'"
          >
            验证码登录
          </button>
          <button
            :class="{ active: activeTab === 'password' }"
            @click="activeTab = 'password'"
          >
            密码登录
          </button>
        </div>

        <!-- 验证码登录 -->
        <div v-if="activeTab === 'verifyCode'" class="login-content">
          <el-input
            v-model="mobile"
            placeholder="请输入手机号"
            prefix-icon="el-icon-mobile-phone"
          ></el-input>
          <div class="slider-container">
            <div
              class="slider-mask"
              :style="{ width: sliderWidth + 'px' }"
            ></div>
            <div
              class="slider-button"
              :style="{ left: sliderLeft + 'px' }"
              @mousedown="startSlide"
              @touchstart="startSlide"
            >
              <i class="el-icon-arrow-right"></i>
            </div>
            <div class="slider-text">{{ sliderText }}</div>
          </div>
          <div class="captcha">
            <el-input
              v-model="captcha"
              placeholder="请输入验证码"
              prefix-icon="el-icon-message"
            ></el-input>
            <button
              class="send-captcha-btn"
              :disabled="!isSliderVerified || !mobile"
              @click="sendCaptcha"
            >
              发送验证码
            </button>
          </div>
          <div class="checkbox">
            <el-checkbox v-model="agreeTerms">
              我已阅读并同意
              <a href="javascript:void(0)" @click="goToHome">《用户协议》</a>
              和
              <a href="javascript:void(0)" @click="goToHome">《隐私协议》</a>
            </el-checkbox>
          </div>
          <el-button
            type="primary"
            class="login-btn"
            @click="handleVerifyCodeLogin"
            >登录</el-button
          >
        </div>

        <!-- 密码登录 -->
        <div v-if="activeTab === 'password'" class="login-content">
          <el-input
            v-model="SetData.username"
            placeholder="请输入用户名"
            prefix-icon="el-icon-user"
          ></el-input>
          <el-input
            v-model="SetData.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
          ></el-input>
          <div class="captcha">
            <el-input
              v-model="SetData.code"
              placeholder="请输入验证码"
              prefix-icon="el-icon-key"
            ></el-input>
            <img
              :src="captchaUrl"
              class="captcha-img"
              @click="refreshCaptcha"
            />
          </div>
          <div class="checkbox">
            <el-checkbox v-model="agreeTerms">
              我已阅读并同意
              <a href="javascript:void(0)" @click="goToHome">《用户协议》</a>
              和
              <a href="javascript:void(0)" @click="goToHome">《隐私协议》</a>
            </el-checkbox>
          </div>
          <el-button
            type="primary"
            class="login-btn"
            @click="handlePasswordLogin"
            >登录</el-button
          >
        </div>
      </div>
    </el-dialog>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../header/head.vue";
import Footer from "../header/footer.vue";
import axios from "axios";

export default {
  components: {
    Header,
    Footer,
  },
  name: "TrainingPage",
  data() {
    return {
      articleItems: [], // 科普文章
      pictureItems: [], // 科普图画
      videoItems: [], // 科普短视频
      lectureItems: [], // 科普讲座
      loadingThumbnails: {},
      loadingImages: {},
      searchForm: {
        projectCode: "",
        projectCase: "",
        worksName: "",
        userName: "",
        userUnit: "",
      },
      // 登录相关数据
      loginDialogVisible: false,
      isLoggedIn: false,
      activeTab: "verifyCode",
      mobile: "",
      captcha: "",
      isSliderVerified: false,
      sliderWidth: 0,
      sliderLeft: 0,
      sliderText: "拖动滑块验证",
      agreeTerms: false,
      SetData: {
        username: "",
        password: "",
        code: "",
        uuid: "",
      },
      captchaUrl: "",
      isDragging: false,
      startX: 0,
      sliderStartLeft: 0,
      activeVideoElements: new Set(), // 存储活动的视频元素
      isComponentActive: true, // 标记组件是否处于活动状态
      thumbnailPromises: [], // 存储所有缩略图生成的Promise
    };
  },
  created() {
    this.checkLoginStatus();
  },
  activated() {
    // 在页面激活时重新获取用户信息
    this.checkLoginStatus();
    // 组件被激活时重置状态
    this.isComponentActive = true;
  },
  methods: {
    // 检查登录状态并获取最新用户信息
    checkLoginStatus() {
      const token = localStorage.getItem("token");
      if (!token) {
        this.isLoggedIn = false;
        this.loginDialogVisible = true;
      } else {
        // 验证token并获取用户信息
        this.$get("/getInfo")
          .then((infoRes) => {
            if (infoRes.data.code === 200) {
              // 保存用户信息
              this.$auth.setUserInfo(infoRes.data.user);
              // 检查白名单权限
              if (infoRes.data.user && infoRes.data.user.isWhite === "1") {
                this.isLoggedIn = true;
                this.fetchAllData();
              } else {
                this.isLoggedIn = false;
                this.$msgbox({
                  title: "提示",
                  message: "暂无查看权限，请联系负责人",
                  showCancelButton: false,
                  confirmButtonText: "确定",
                  type: "warning",
                  callback: () => {
                    this.$router.push("/");
                  },
                });
              }
            } else {
              this.isLoggedIn = false;
              this.loginDialogVisible = true;
              this.$message.error(infoRes.data.msg || "登录失效，请重新登录");
            }
          })
          .catch(() => {
            this.isLoggedIn = false;
            this.loginDialogVisible = true;
            this.$message.error("登录失效，请重新登录");
          });
      }
    },
    async fetchAllData() {
      try {
        // 分别获取不同类型的数据
        const [articleRes, pictureRes, videoRes, lectureRes] =
          await Promise.all([
            this.$get("/system/peixun/list?type=1"), // 培训文件
            this.$get("/system/peixun/list?type=2"), // 科普图画
            this.$get("/system/peixun/list?type=3"), // 培训视频
            this.$get("/system/peixun/list?type=4"), // 科普讲座
          ]);

        // 处理培训文件数据
        if (articleRes.data.code === 200) {
          this.articleItems = articleRes.data.rows || [];
        } else {
          this.articleItems = [];
          console.error("获取培训文件失败:", articleRes.data.msg);
        }

        // 处理科普图画数据
        if (pictureRes.data.code === 200) {
          this.pictureItems = pictureRes.data.rows || [];
          this.pictureItems.forEach((item) => {
            this.$set(this.loadingImages, item.id, true);
          });
        } else {
          this.pictureItems = [];
          console.error("获取科普图画失败:", pictureRes.data.msg);
        }

        // 处理培训视频数据
        if (videoRes.data.code === 200) {
          this.videoItems = videoRes.data.rows || [];
        } else {
          this.videoItems = [];
          console.error("获取培训视频失败:", videoRes.data.msg);
        }

        // 处理科普讲座数据
        if (lectureRes.data.code === 200) {
          this.lectureItems = lectureRes.data.rows || [];
        } else {
          this.lectureItems = [];
          console.error("获取科普讲座失败:", lectureRes.data.msg);
        }

        // 处理视频缩略图
        const allVideoItems = [...this.videoItems, ...this.lectureItems];
        await this.processVideoThumbnails(allVideoItems);
      } catch (error) {
        console.error("获取数据失败：", error);
        this.$message.error("获取数据失败，请稍后重试");
      }
    },

    viewAllWorks(worksType) {
      this.$router.push({
        path: "/all-works",
        query: { worksType },
      });
    },

    // 处理搜索
    async handleSearch() {
      try {
        // 构建搜索参数字符串
        const searchParams = new URLSearchParams(this.searchForm).toString();
        const baseUrl1 = searchParams
          ? `/system/peixun/list?type=1&${searchParams}`
          : "/system/peixun/list?type=1";
        const baseUrl2 = searchParams
          ? `/system/peixun/list?type=2&${searchParams}`
          : "/system/peixun/list?type=2";
        const baseUrl3 = searchParams
          ? `/system/peixun/list?type=3&${searchParams}`
          : "/system/peixun/list?type=3";
        const baseUrl4 = searchParams
          ? `/system/peixun/list?type=4&${searchParams}`
          : "/system/peixun/list?type=4";

        // 分别获取不同类型的数据，传递搜索参数
        const [articleRes, pictureRes, videoRes, lectureRes] =
          await Promise.all([
            this.$get(baseUrl1), // 培训文件
            this.$get(baseUrl2), // 科普图画
            this.$get(baseUrl3), // 培训视频
            this.$get(baseUrl4), // 科普讲座
          ]);

        // 处理培训文件数据
        if (articleRes.data.code === 200) {
          this.articleItems = articleRes.data.rows || [];
        } else {
          this.articleItems = [];
          console.error("搜索培训文件失败:", articleRes.data.msg);
        }

        // 处理科普图画数据
        if (pictureRes.data.code === 200) {
          this.pictureItems = pictureRes.data.rows || [];
          this.pictureItems.forEach((item) => {
            this.$set(this.loadingImages, item.id, true);
          });
        } else {
          this.pictureItems = [];
          console.error("搜索科普图画失败:", pictureRes.data.msg);
        }

        // 处理培训视频数据
        if (videoRes.data.code === 200) {
          this.videoItems = videoRes.data.rows || [];
        } else {
          this.videoItems = [];
          console.error("搜索培训视频失败:", videoRes.data.msg);
        }

        // 处理科普讲座数据
        if (lectureRes.data.code === 200) {
          this.lectureItems = lectureRes.data.rows || [];
        } else {
          this.lectureItems = [];
          console.error("搜索科普讲座失败:", lectureRes.data.msg);
        }

        // 处理视频缩略图
        const allVideoItems = [...this.videoItems, ...this.lectureItems];
        await this.processVideoThumbnails(allVideoItems);
      } catch (error) {
        console.error("搜索失败：", error);
        this.$message.error("搜索失败，请稍后重试");
      }
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        projectCode: "",
        projectCase: "",
        worksName: "",
        userName: "",
        userUnit: "",
      };
      this.fetchAllData(); // 重新获取所有数据
    },

    // 处理视频缩略图
    async processVideoThumbnails(items) {
      const thumbnailPromises = items
        .filter((item) => item.vedioFile)
        .map(async (item) => {
          if (item.vedioFile) {
            try {
              this.$set(this.loadingThumbnails, item.id, true);
              const thumbnail = await this.getVideoThumbnail(item.vedioFile);
              if (thumbnail) {
                item.picFile = thumbnail;
              }
            } catch (error) {
              console.error("处理视频缩略图失败:", error);
            } finally {
              this.$set(this.loadingThumbnails, item.id, false);
            }
          }
        });

      await Promise.all(thumbnailPromises);
    },

    // 清理所有视频相关资源
    cleanupVideoResources() {
      this.isComponentActive = false;
      this.thumbnailPromises = [];

      // 清理所有活动的视频元素
      this.activeVideoElements.forEach((video) => {
        try {
          // 停止所有媒体加载
          video.pause();
          video.removeAttribute("src");
          video.load();
          // 移除所有事件监听器
          video.onloadeddata = null;
          video.onseeked = null;
          video.onerror = null;
          // 清空视频源
          video.src = "";
          // 移除视频元素
          video.remove();
        } catch (error) {
          console.error("清理视频元素失败:", error);
        }
      });
      this.activeVideoElements.clear();

      // 重置加载状态
      Object.keys(this.loadingThumbnails).forEach((key) => {
        this.$set(this.loadingThumbnails, key, false);
      });

      // 清理所有视频引用
      if (this.$refs.videoRefs) {
        this.$refs.videoRefs.forEach((video) => {
          if (video) {
            try {
              video.pause();
              video.removeAttribute("src");
              video.load();
              video.onloadeddata = null;
              video.onseeked = null;
              video.onerror = null;
              video.src = "";
            } catch (error) {
              console.error("清理视频引用失败:", error);
            }
          }
        });
      }

      // 清空视频数据
      this.videos = [];
    },

    // 修改生成视频缩略图的方法
    async getVideoThumbnail(videoUrl) {
      if (!videoUrl || !this.isComponentActive) return null;

      try {
        return new Promise((resolve, reject) => {
          const video = document.createElement("video");
          this.activeVideoElements.add(video);

          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");

          video.crossOrigin = "anonymous";
          let retryCount = 0;
          const maxRetries = 10;

          const cleanupVideo = () => {
            try {
              video.pause();
              video.removeAttribute("src");
              video.load();
              video.onloadeddata = null;
              video.onseeked = null;
              video.onerror = null;
              video.src = "";
              video.remove();
            } catch (error) {
              console.error("清理视频元素失败:", error);
            }
            this.activeVideoElements.delete(video);
          };

          const tryCapture = () => {
            if (!this.isComponentActive) {
              cleanupVideo();
              resolve(null);
              return;
            }

            try {
              if (video.readyState >= 3) {
                const videoRatio = video.videoWidth / video.videoHeight;

                if (videoRatio > 1) {
                  canvas.width = 320;
                  canvas.height = 320 / videoRatio;
                } else {
                  canvas.height = 320;
                  canvas.width = 320 * videoRatio;
                }

                context.drawImage(
                  video,
                  0,
                  0,
                  video.videoWidth,
                  video.videoHeight,
                  0,
                  0,
                  canvas.width,
                  canvas.height,
                );

                const thumbnailUrl = canvas.toDataURL("image/jpeg", 0.9);
                cleanupVideo();
                resolve(thumbnailUrl);
              } else if (retryCount < maxRetries) {
                retryCount++;
                setTimeout(tryCapture, 1000);
              } else {
                video.load();
                retryCount = 0;
                setTimeout(tryCapture, 2000);
              }
            } catch (error) {
              if (!this.isComponentActive) {
                cleanupVideo();
                resolve(null);
                return;
              }
              if (retryCount < maxRetries) {
                retryCount++;
                setTimeout(tryCapture, 1000);
              } else {
                video.load();
                retryCount = 0;
                setTimeout(tryCapture, 2000);
              }
            }
          };

          // 设置超时清理
          const timeoutId = setTimeout(() => {
            if (this.activeVideoElements.has(video)) {
              cleanupVideo();
              resolve(null);
            }
          }, 30000); // 30秒超时

          video.onloadeddata = () => {
            if (this.isComponentActive) {
              video.currentTime = 0;
            } else {
              cleanupVideo();
              resolve(null);
            }
          };

          video.onseeked = tryCapture;
          video.onerror = () => {
            if (!this.isComponentActive) {
              cleanupVideo();
              resolve(null);
              return;
            }
            if (retryCount < maxRetries) {
              retryCount++;
              setTimeout(() => {
                video.load();
                tryCapture();
              }, 2000);
            } else {
              video.load();
              retryCount = 0;
              setTimeout(tryCapture, 2000);
            }
          };

          // 在Promise resolve时清理超时计时器
          const originalResolve = resolve;
          resolve = (value) => {
            clearTimeout(timeoutId);
            originalResolve(value);
          };

          video.src = videoUrl;
          video.preload = "auto";
        });
      } catch (error) {
        console.error("获取视频缩略图失败:", error);
        if (this.isComponentActive) {
          return this.getVideoThumbnail(videoUrl);
        }
        return null;
      }
    },
    handleItemClick(item) {
      // 所有类型都跳转到同一个路由，只传递peixunvideoId
      this.$router.push({
        path: "/sample-video",
        query: {
          peixunvideoId: item.id,
        },
      });
    },
    // 新增：处理图片加载完成
    handleImageLoad(itemId) {
      this.$set(this.loadingImages, itemId, false);
    },

    // 新增：处理图片加载失败
    handleImageError(itemId) {
      this.$set(this.loadingImages, itemId, false);
    },

    // 登录相关方法
    handleVerifyCodeLogin() {
      if (!this.agreeTerms) {
        this.$message.error("请同意用户协议与隐私协议！");
        return;
      }
      if (!this.captcha) {
        this.$message.error("请输入验证码！");
        return;
      }
      this.$post(`/loginSms?phoneNumber=${this.mobile}&code=${this.captcha}`)
        .then((res) => {
          if (res.data.code === 200) {
            this.$auth.setToken(res.data.data);
            this.$get("/getInfo")
              .then((infoRes) => {
                if (infoRes.data.code === 200) {
                  // 保存用户信息
                  this.$auth.setUserInfo(infoRes.data.user);
                  // 检查白名单权限
                  if (infoRes.data.user && infoRes.data.user.isWhite === "1") {
                    this.isLoggedIn = true;
                    this.$message.success("登录成功");
                    this.$bus.$emit("updateUser");
                    this.loginDialogVisible = false;
                    this.fetchAllData();
                  } else {
                    this.$msgbox({
                      title: "提示",
                      message: "暂无查看权限，请联系负责人",
                      showCancelButton: false,
                      confirmButtonText: "确定",
                      type: "warning",
                      callback: () => {
                        this.$router.push("/");
                      },
                    });
                  }
                } else {
                  this.$message.error(
                    infoRes.data.msg || "登录失效，请重新登录",
                  );
                }
              })
              .catch(() => {
                this.$message.error("登录失效，请重新登录");
              });
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          this.$message.error("登录失败");
        });
    },

    handlePasswordLogin() {
      if (
        !this.SetData.username ||
        !this.SetData.password ||
        !this.SetData.code
      ) {
        this.$message.error("请填写完整信息！");
        return;
      }
      if (!this.agreeTerms) {
        this.$message.error("请同意用户协议与隐私协议！");
        return;
      }
      const loginData = {
        username: this.SetData.username,
        password: this.SetData.password,
        code: this.SetData.code,
        uuid: this.SetData.uuid,
      };
      this.$post("/login", loginData).then((res) => {
        if (res.data.code === 200) {
          this.$auth.setToken(res.data.token);
          this.$get("/getInfo")
            .then((infoRes) => {
              if (infoRes.data.code === 200) {
                // 保存用户信息
                this.$auth.setUserInfo(infoRes.data.user);
                // 检查白名单权限
                if (infoRes.data.user && infoRes.data.user.isWhite === "1") {
                  this.isLoggedIn = true;
                  this.$message.success("登录成功");
                  this.$bus.$emit("updateUser");
                  this.loginDialogVisible = false;
                  this.fetchAllData();
                } else {
                  this.$msgbox({
                    title: "提示",
                    message: "暂无查看权限，请联系负责人",
                    showCancelButton: false,
                    confirmButtonText: "确定",
                    type: "warning",
                    callback: () => {
                      this.$router.push("/");
                    },
                  });
                }
              } else {
                this.$message.error(infoRes.data.msg || "登录失效，请重新登录");
              }
            })
            .catch(() => {
              this.$message.error("登录失效，请重新登录");
            });
        } else {
          this.$message.error(res.data.msg);
          this.refreshCaptcha();
        }
      });
    },

    sendCaptcha() {
      if (!this.isSliderVerified) {
        this.$message.warning("请先完成滑块验证");
        return;
      }
      if (!this.mobile) {
        this.$message.error("请输入手机号！");
        return;
      }
      // 验证手机号格式
      if (!/^1[3-9]\d{9}$/.test(this.mobile)) {
        this.$message.error("请输入正确的手机号！");
        return;
      }
      this.$post(`/smsSend?phoneNumber=${this.mobile}`)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success(res.data.msg || "验证码已发送，请查收！");
          } else {
            this.$message.error(res.data.msg || "验证码发送失败");
          }
          this.isSliderVerified = false;
          this.sliderLeft = 0;
          this.sliderWidth = 0;
          this.sliderText = "请向右滑动验证";
        })
        .catch(() => {
          this.$message.error("验证码发送失败");
        });
    },

    startSlide(e) {
      this.isDragging = true;
      this.startX = e.clientX || (e.touches && e.touches[0].clientX) || 0;
      this.sliderStartLeft = this.sliderLeft;

      document.addEventListener("mousemove", this.moveSlide);
      document.addEventListener("mouseup", this.endSlide);
      document.addEventListener("touchmove", this.moveSlide, {
        passive: false,
      });
      document.addEventListener("touchend", this.endSlide);

      if (e.type === "touchstart") {
        e.preventDefault();
      }
    },

    moveSlide(e) {
      if (!this.isDragging) return;

      const currentX = e.clientX || (e.touches && e.touches[0].clientX) || 0;
      const containerWidth = 315;
      const buttonWidth = 34;

      const deltaX = currentX - this.startX;
      let newLeft = this.sliderStartLeft + deltaX;

      newLeft = Math.max(0, Math.min(newLeft, containerWidth - buttonWidth));

      this.sliderLeft = newLeft;
      this.sliderWidth = newLeft + buttonWidth;

      if (newLeft >= containerWidth - buttonWidth - 2) {
        this.verifySlider();
      }

      if (e.type === "touchmove") {
        e.preventDefault();
      }
    },

    endSlide() {
      this.isDragging = false;

      document.removeEventListener("mousemove", this.moveSlide);
      document.removeEventListener("mouseup", this.endSlide);
      document.removeEventListener("touchmove", this.moveSlide);
      document.removeEventListener("touchend", this.endSlide);

      if (!this.isSliderVerified) {
        this.sliderLeft = 0;
        this.sliderWidth = 0;
      } else {
        const containerWidth = 315;
        const buttonWidth = 34;
        this.sliderLeft = containerWidth - buttonWidth;
        this.sliderWidth = containerWidth;
      }
    },

    verifySlider() {
      this.isSliderVerified = true;
      this.sliderText = "验证通过";
    },

    refreshCaptcha() {
      this.$get("/captchaImage").then((res) => {
        if (res.data.code == 200) {
          this.captchaUrl = "data:image/gif;base64," + res.data.img;
          this.SetData.uuid = res.data.uuid;
        }
      });
    },

    handleDialogClose(done) {
      this.$router.push("/");
      done();
    },

    goToHome() {
      this.$router.push("/");
    },
  },
  watch: {
    activeTab(newVal) {
      if (newVal === "password") {
        this.refreshCaptcha();
      }
    },
  },
  beforeDestroy() {
    // 清理所有视频相关资源
    this.cleanupVideoResources();
  },
  deactivated() {
    // 组件被停用时清理视频状态
    this.cleanupVideoResources();
  },
};
</script>

<style scoped>
.training-page {
  padding: 20px 50px;
  background: #f5f5f5;
  min-height: 100vh;
}

.search-section {
  margin-bottom: 20px;
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.search-form .el-form-item {
  margin-bottom: 0;
  margin-right: 0;
}

.search-form :deep(.el-form-item__label) {
  font-weight: bold;
  color: #333;
}

.search-form .el-input {
  width: 200px;
}

/* 修改搜索按钮颜色 */
.search-form :deep(.el-button--primary) {
  background-color: #58c1b6 !important;
  border-color: #58c1b6 !important;
}

.search-form :deep(.el-button--primary:hover),
.search-form :deep(.el-button--primary:focus) {
  background-color: #4ba89e !important;
  border-color: #4ba89e !important;
}

.search-form :deep(.el-button--primary:active) {
  background-color: #3e8f86 !important;
  border-color: #3e8f86 !important;
}

/* 修改"全部作品"链接颜色 */
.view-all {
  cursor: pointer;
  color: #58c1b6;
  font-size: 14px;
  padding: 5px 10px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.view-all:hover {
  background-color: #f0f9f8;
  color: #4ba89e;
}

@media screen and (max-width: 768px) {
  .training-page {
    padding: 20px;
  }

  .search-form {
    flex-direction: column;
  }

  .search-form .el-form-item {
    width: 100%;
    margin-bottom: 10px;
  }

  .search-form .el-input {
    width: 100%;
  }
}

.section {
  margin-bottom: 40px;
}

.section-header {
  position: relative;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
}

h2 {
  text-align: left;
  margin: 0;
  padding: 10px 0;
  color: #333;
  font-size: 20px;
  font-weight: bold;
}

.works-grid {
  display: grid;
  grid-template-columns: repeat(5, 248px);
  gap: 20px;
  margin: 20px auto;
  max-width: 1340px;
  padding: 0 30px;
  justify-content: center;
}

.works-item {
  width: 248px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.works-player-wrap {
  width: 248px;
  height: 440px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.works-player-wrap:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.works-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  position: relative;
}

.works-cover {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  padding: 0;
  box-sizing: border-box;
}

.works-item[data-type="1"] .works-cover {
  padding: 0;
  width: 100% !important;
  height: auto !important;
  object-fit: contain !important;
  margin: 0 !important;
}

.works-item[data-type="2"] .works-cover {
  object-fit: cover;
  padding: 0;
}

.works-item[data-type="3"] .works-cover,
.works-item[data-type="4"] .works-cover {
  object-fit: contain;
  padding: 0;
}

.works-title {
  margin-top: 8px;
  font-size: 14px;
  text-align: center;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 5px;
  width: 100%;
  max-width: 248px;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}

.loading-overlay i {
  font-size: 24px;
  color: #409eff;
}

.video-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  position: relative;
  overflow: hidden;
}

.video-container .works-cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #000;
  margin: 0;
  padding: 0;
}

/* 如果是讲座视频，保持原有比例 */
.works-item[data-type="4"] .video-container .works-cover {
  object-fit: contain;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
}

.image-slot i {
  font-size: 30px;
}

@media screen and (max-width: 1400px) {
  .works-grid {
    grid-template-columns: repeat(4, 248px);
    max-width: 1092px;
  }
}

@media screen and (max-width: 1200px) {
  .works-grid {
    grid-template-columns: repeat(3, 248px);
    max-width: 804px;
  }
}

@media screen and (max-width: 768px) {
  .works-grid {
    display: flex;
    gap: 10px;
    padding-bottom: 20px;
    flex-wrap: wrap;
    justify-content: center;
  }

  .works-item {
    width: calc(50% - 5px);
    max-width: 240px;
    margin-bottom: 10px;
  }

  .works-player-wrap {
    width: 100%;
    height: 200px;
  }

  .works-title {
    font-size: 12px;
    margin-top: 5px;
    width: 100%;
    max-width: 100%;
  }
}

/* 添加登录弹窗相关样式 */
.login-dialog {
  border-radius: 8px;
}

.login-dialog :deep(.el-dialog__header) {
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.login-dialog :deep(.el-dialog__title) {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.login-dialog :deep(.el-dialog__headerbtn) {
  top: 20px;
  right: 20px;
}

.login-dialog :deep(.el-dialog__headerbtn .el-dialog__close) {
  font-size: 18px;
  color: #666;
}

.login-form {
  padding: 20px;
}

.login-tabs {
  display: flex;
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.login-tabs button {
  flex: 1;
  padding: 10px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  position: relative;
}

.login-tabs button.active {
  color: #58c1b6;
}

.login-tabs button.active::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #58c1b6;
}

.login-content {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.login-content .el-input {
  margin-bottom: 0;
}

.slider-container {
  position: relative;
  width: 100%;
  height: 40px;
  background: #f5f5f5;
  border-radius: 4px;
  margin: 10px 0;
}

.slider-mask {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background: #e8f7f6;
  border-radius: 4px;
  transition: width 0.1s;
}

.slider-button {
  position: absolute;
  width: 40px;
  height: 40px;
  background: white;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: left 0.1s;
  z-index: 2;
}

.slider-text {
  position: absolute;
  width: 100%;
  text-align: center;
  line-height: 40px;
  color: #999;
  user-select: none;
}

.captcha {
  display: flex;
  gap: 10px;
}

.captcha .el-input {
  flex: 1;
}

.send-captcha-btn {
  padding: 0 15px;
  background: #58c1b6;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
}

.send-captcha-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.captcha-img {
  height: 40px;
  width: 100px;
  cursor: pointer;
  border-radius: 4px;
}

.checkbox {
  margin: 10px 0;
}

.checkbox a {
  color: #58c1b6;
  text-decoration: none;
}

.login-btn {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  margin-top: 10px;
  background-color: #58c1b6 !important;
  border-color: #58c1b6 !important;
}

/* 复选框相关样式 */
.checkbox :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
  background-color: #58c1b6;
  border-color: #58c1b6;
}

.checkbox :deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
  color: #58c1b6;
}

.checkbox :deep(.el-checkbox__input.is-focus .el-checkbox__inner) {
  border-color: #58c1b6;
}

.checkbox :deep(.el-checkbox__inner:hover) {
  border-color: #58c1b6;
}

.checkbox :deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner) {
  background-color: #58c1b6;
  border-color: #58c1b6;
}

.checkbox
  :deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner::before) {
  background-color: #fff;
}

/* 移动端适配 */
@media only screen and (max-width: 768px) {
  .login-dialog {
    width: 90% !important;
    margin: 0 auto;
  }

  .login-form {
    padding: 15px;
  }

  .login-tabs button {
    font-size: 14px;
    padding: 8px;
  }

  .send-captcha-btn {
    padding: 0 10px;
    font-size: 12px;
  }
}
</style>
